/* eslint-disable */
import {
  Checkbox,
  Flex,
  Popover,
  Radio,
  Space,
  Button,
  Dropdown,
  Modal,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  CaretDownOutlined,
  OneToOneOutlined,
  SyncOutlined,
  LoadingOutlined,
  VerticalAlignBottomOutlined,
  MenuOutlined,
  EditOutlined,
  PlusOutlined,
  DeleteOutlined 
} from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import moment from "moment";
import { CustomTable,CustomTableExtend } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
import AddModal from "./component/addModal";
import ResetModal from "./component/editModal";
import "./component/index.scss";
export default function TrustIndex() {
  const addModalRef = useRef(null);
  const EditModal = useRef(null);
  // 默认选中的值
  const [selectedItems, setSelectedItems] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 500,
    total: 0,
  });


  const GlChartList = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
    { label: "STORE", value: 3 },
  ];
  const ServiceChartList = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
  ];
  // 处理选项变化
  const handleChange = (checkedValues) => {
    setSelectedItems(checkedValues);
    setColumns(
      initColumns.map((item) => ({
        ...item,
        hidden: !checkedValues.includes(item.dataIndex),
      }))
    );
  };

  const showModal = () => {
    addModalRef.current?.setModelAdd();
  };
  // Popover 的内容
  const content = (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Checkbox.Group
        options={options}
        value={selectedItems}
        className="checkBox"
        onChange={handleChange}
      >
        <Space direction="vertical">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Space>
      </Checkbox.Group>
    </div>
  );

  const handleMenuClick = async (e, record) => {
    console.log(record, "record");
    if (e.key === "edit") {
      EditModal.current?.open(record);
    }

    if (e.key === "upload") {
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys) => setSelectedRowKeys(keys),
  };
  const handleExport = async () => {
    if (exportLoading) return; // 防止重复点击

    setExportLoading(true);

    try {
      const params = {
        page: pagination.current,
        count: pagination.pageSize,
        ...tableHead,
      };
      const response = await http.get(api.getTrustExcel, {
        params,
        responseType: "blob",
      });

      const blob = new Blob([response], { type: "application/vnd.ms-excel" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `Entity_List_${moment().format("MM/DD/YYYY")}.xlsx`;
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      message.error("Failed to export file");
    } finally {
      setExportLoading(false);
    }
  };
  const content2 = (
    <div
      onClick={!exportLoading ? handleExport : undefined}
      style={{ cursor: exportLoading ? "not-allowed" : "pointer" }}
    >
      {exportLoading ? "Exporting..." : "Export to CSV"}
    </div>
  );
  // table
  const initTableHead = {
    role: null,
    module: null,
    firstName: null,
    dateTimeRequest: null,
  };
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };

  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "bankId",
      hidden: false,
      align: "center",
      width: 50,
       render: (text, record) => (
        (
          commonFn.btnAuthorityFlag('EditTrust') 
        ) && (<Dropdown
            menu={{
              items: [
                commonFn.btnAuthorityFlag('EditTrust') && {
                  key: "edit",
                  icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "16px" }} />,
                  label: <div>Edit Trust Information</div>,
                },
              
              ],
              onClick: (e) => handleMenuClick(e, record),
            }}
            trigger={["click"]}
          >
            <MenuOutlined
              style={{ cursor: "pointer", fontSize: "16px", color: "#0e78a9" }}
            />
          </Dropdown>)
      ),
   
    },


    {
      title: "Entity Name",
      dataIndex: "trustName",
      titleType: "Input",
      width:220,
      onChange: (e) => tableFilterFn(e, "trustName"),
    },
        {
      title: "Entity Code",
      dataIndex: "trust",
      titleType: "Input",
      width:100,
      onChange: (e) => tableFilterFn(e, "trust"),
    },
      {
      title: "GL Chart",
      dataIndex: "glChartName",
      titleType: "Select",
      selectOptions: GlChartList,
      width: 80,
      onChange: (e) => tableFilterFn(e, "glChartName", "Select"),
    },
    {
      title: "Service Chart",
      dataIndex: "serviceName",
      titleType: "Select",
      width: 80,
      selectOptions: ServiceChartList,
      onChange: (e) => tableFilterFn(e, "serviceName", "Select"),
    },
       {
      title: "Owner",
      dataIndex: "ownerName",
      titleType: "Input",
       width:200,
      onChange: (e) => tableFilterFn(e, "ownerName"),
    },
         {
      title: "Active Bank Accounts",
      dataIndex: "bankCount",
       width:100,
    },
         {
      title: "Active Properties",
      dataIndex: "propCount",
       width:100,
    },
    {
      title: "Federal Tax ID",
      dataIndex: "fedId",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "fedId"),
    },
     {
      title: "State Tax ID",
      dataIndex: "stateId",
      titleType: "Input",
      width: 100,
      onChange: (e) => tableFilterFn(e, "stateId"),
    },
     {
      title: "Mailing Address",
      dataIndex: "address",
      titleType: "Input",
      width: 250,
      onChange: (e) => tableFilterFn(e, "address"),
    },
     {
      title: "Active",
      dataIndex: "active",
      titleType: "Select",
       width:80,
      selectOptions: [
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
      ],
      onChange: (value) => tableFilterFn(value, "active", "Select"),
      render: (value) => (value === 1 ? "Active" : "Inactive"),
    },
  ];

  // 获取列表数据
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
    };
    const response = await http.get(api.getTrustData, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const list = (response.data.list || []).map((item, index) => ({
      ...item,
      "#": (params.page - 1) * params.count + index + 1,
      key: item.bankId,
    }));
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns(initColumns);
    const transformedList = initColumns.map((item) => ({
      label: item.title,
      value: item.dataIndex,
    }));
    setOptions(transformedList);
    const transformedList2 = initColumns.map((item) => item.dataIndex);
    setSelectedItems(transformedList2);
  };

  const handleDelete = async () => {
    if (selectedRowKeys.length === 0) {
      return message.warning("Please select at least one record.");
    }

    Modal.confirm({
      title: "Confirm Delete",
      content: `Are you sure you want to delete ${selectedRowKeys.length} items?`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",

      onOk: async () => {
        try {
          const ids = selectedRowKeys.join(",");
          const res = await http.get(api.getTrustDelete, {
            params: { trustId: ids },
          });

          if (res.code === "1") {
            message.success("Delete Successfully");
            setSelectedRowKeys([]);

            setRefreshKey(Date.now());
          } else {
            message.error(res.msg || "Delete Failed");
          }
        } catch (err) {
          message.error("Request Error");
        } finally {
          // setTableLoading(false);
        }
      },
    });
  };

  useEffect(() => {
    initColunmsFn();
    getTableListFn(1, 500);
  }, [refreshKey]);

  return (
    <div>

      <CustomTableExtend
  setColumns={setColumns}
  initColumns={initColumns}
  refreshKey={refreshKey}
  setRefreshKey={setRefreshKey}
  noShowList={["download"]} 
  extraBtnChildren={
    <Radio.Button value="download">
      <Popover content={content2} title="" trigger="click">
        {exportLoading ? <LoadingOutlined /> : <VerticalAlignBottomOutlined />}
        <CaretDownOutlined style={{ fontSize: "12px", marginLeft: "3px" }} />
      </Popover>
    </Radio.Button>
  }
>
  <div>
    <Button className="btnNew" onClick={showModal}>
      <PlusOutlined />
      New
    </Button>
    <Button className="btnDEL" onClick={handleDelete}>
      <DeleteOutlined />
      Delete
    </Button>
  </div>
</CustomTableExtend>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableCss="maintenanceTable"
        rowKey="trustId"
        rowSelection={rowSelection}
      />
      <AddModal
        ref={addModalRef}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />

      {/* ResetModal */}
      <ResetModal
        ref={EditModal}
        onSuccess={() => {
          getTableListFn(pagination.current, pagination.pageSize, tableHead);
        }}
      />
    </div>
  );
}
